"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleAvatar = void 0;
const design_player_avatar_list_1 = require("@unboared/design.player.avatar_list");
const sampleFromList = (list) => {
    return list[Math.floor(Math.random() * list.length)];
};
const sampleAvatar = () => {
    return sampleFromList(design_player_avatar_list_1.avatar_list);
};
exports.sampleAvatar = sampleAvatar;
//# sourceMappingURL=index.js.map